/**
 * Entities store
 */

import { create } from 'zustand';
import { Entity } from '../types/api';

interface EntitiesState {
  selectedEntityType: string | null;
  filters: Record<string, any>;
  sortBy: string | null;
  sortOrder: 'asc' | 'desc';
  selectedEntities: Set<string>;
  
  setEntityType: (entityType: string) => void;
  setFilters: (filters: Record<string, any>) => void;
  setSorting: (sortBy: string, sortOrder: 'asc' | 'desc') => void;
  toggleEntitySelection: (entityId: string) => void;
  clearSelection: () => void;
  reset: () => void;
}

export const useEntitiesStore = create<EntitiesState>((set) => ({
  selectedEntityType: null,
  filters: {},
  sortBy: null,
  sortOrder: 'asc',
  selectedEntities: new Set(),
  
  setEntityType: (entityType) => set({ selectedEntityType: entityType, filters: {}, selectedEntities: new Set() }),
  
  setFilters: (filters) => set({ filters }),
  
  setSorting: (sortBy, sortOrder) => set({ sortBy, sortOrder }),
  
  toggleEntitySelection: (entityId) => set((state) => {
    const newSet = new Set(state.selectedEntities);
    if (newSet.has(entityId)) {
      newSet.delete(entityId);
    } else {
      newSet.add(entityId);
    }
    return { selectedEntities: newSet };
  }),
  
  clearSelection: () => set({ selectedEntities: new Set() }),
  
  reset: () => set({
    selectedEntityType: null,
    filters: {},
    sortBy: null,
    sortOrder: 'asc',
    selectedEntities: new Set(),
  }),
}));


